if (!customElements.get("faq-accordion")) {
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll("[data-faq-item]"));
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener("click", this.handleClick);
    }

    setOpen(item, isOpen) {
      const panel = item.querySelector("[data-faq-panel]");

      item.classList.toggle("state--open", isOpen);
      item.querySelector("[data-faq-toggle]").setAttribute("aria-expanded", isOpen.toString());
      panel.inert = !isOpen;
    }

    handleClick(event) {
      const toggle = event.target.closest("[data-faq-toggle]");

      if (!toggle || !this.contains(toggle)) return;

      const activeItem = toggle.closest("[data-faq-item]");
      const shouldOpen = !activeItem.classList.contains("state--open");

      this.items.forEach((item) => this.setOpen(item, item === activeItem && shouldOpen));
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
    }
  }

  class FaqTabs extends FaqAccordion {
    connectedCallback() {
      this.nav = this.querySelector("[data-faq-nav]");
      this.groups = Array.from(this.querySelectorAll("[data-faq-group]"));

      if (!this.nav || !this.groups.length) return;

      super.connectedCallback();
      this.nav.replaceChildren();

      this.links = this.groups.map((group, index) => {
        const link = document.createElement("a");

        link.className = "faq-nav-link size-1 small--size--1 text-upper";
        link.href = `#${group.id}`;
        link.dataset.faqTarget = group.id;
        link.textContent = group.dataset.faqLabel;

        this.nav.appendChild(link);

        if (index === 0) this.setActive(link);

        return link;
      });

      this.items.forEach((item) => this.setOpen(item, false));

      this.observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (!visible) return;

        this.links.forEach((link) => {
          this.setActive(link, link.dataset.faqTarget === visible.target.id);
        });
      }, {
        rootMargin: "-20% 0px -65% 0px",
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });

      this.groups.forEach((group) => this.observer.observe(group));
    }

    setActive(link, isActive = true) {
      link.classList.toggle("state--active", isActive);

      if (isActive) {
        link.setAttribute("aria-current", "true");
      } else {
        link.removeAttribute("aria-current");
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.observer?.disconnect();
    }
  }

  customElements.define("faq-accordion", FaqAccordion);
  customElements.define("faq-tabs", FaqTabs);
}
